module.exports = __webpack_public_path__ + "img/fish1.1ecac33a.png";